/**
 * Feature flags lato frontend.
 *
 * Convenzione: ogni feature flag è una funzione che ritorna boolean.
 * Le funzioni leggono variabili d'ambiente (REACT_APP_*) e/o controlli
 * runtime (es. piattaforma Capacitor).
 *
 * Per attivare/disattivare un flag:
 *   - modificare /app/frontend/.env (variabile REACT_APP_*)
 *   - riavviare il frontend (sudo supervisorctl restart frontend)
 *   - rebuild produzione se necessario
 */

/**
 * Acquisizione foto direttamente da tricocamera WiFi.
 *
 * Beta. Visibile solo:
 *   - se la variabile d'ambiente REACT_APP_TRICHO_BETA_CAPTURE è "true"
 *   - in preview web (con mock webcam) per validazione UX
 *   - in app Capacitor nativa (iOS/Android) per uso reale con plugin nativo
 */
export function isTrichoBetaCaptureEnabled() {
  const env = String(process.env.REACT_APP_TRICHO_BETA_CAPTURE || "").toLowerCase();
  return env === "true" || env === "1" || env === "on";
}

/**
 * Indica se siamo dentro un wrapper nativo Capacitor (iOS/Android).
 * In preview web ritorna false. Quando il plugin reale verrà installato,
 * questa funzione individuerà l'app nativa e si userà il plugin reale al
 * posto del mock webcam.
 */
export function isCapacitorNative() {
  if (typeof window === "undefined") return false;
  const cap = window.Capacitor;
  if (!cap) return false;
  if (typeof cap.isNativePlatform === "function") return cap.isNativePlatform();
  return false;
}
